<ng-container *ngIf="configuration$ | async as configuration">
  <ng-container *ngIf="configuration?.groups?.length > 1">
    <button
      class="cx-btn btn btn-action"
      [disabled]="isFirstGroup(configuration.owner) | async"
      (click)="onPrevious(configuration)"
    >
      {{ 'configurator.button.previous' | cxTranslate }}
    </button>
    <button
      class="cx-btn btn btn-secondary"
      [disabled]="isLastGroup(configuration.owner) | async"
      (click)="onNext(configuration)"
    >
      {{ 'configurator.button.next' | cxTranslate }}
    </button>
  </ng-container>
</ng-container>
